import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import {
  Table,
  ButtonGroup,
  IconButton,
  Icon,
  Panel,
  Row,
  Form,
  Col,
  Grid,
  Avatar,
  Input,
  ControlLabel,
  Button,
} from 'rsuite'
import AppContext from '../../../context/AppContext'
import TablePagination from 'rsuite/lib/Table/TablePagination'

export default function ProjectClosedLateTable({
  schema,
  pagination,
  onReload,
  loading,
  hiddenColStatus,
  onSearchCommittee,
  onEdit,
  onDownload,
  onDelete,
  expand: _expand,
  onSelect,
  hideColumn,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [tableData, setTableData] = useState([])
  const [inputValProjectCode, setInputValProjectCode] = useState('')
  const [inputValProjectName, setInputValProjectName] = useState('')
  const [inputValueIdCard, setInputValueIdCard] = useState('')
  const [showAddPanel, setShowAddPanel] = useState(false)
  const [section, setSection] = useState()
  const [expand, setExpand] = useState(true)

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema.values) {
      setTableData(schema.values)
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  return (
    <>
      {/* <Panel
        header={'รายการโครงการปิดล่าช้า'}
        bordered
        collapsible
        shaded
        defaultExpanded
        expanded={expand}
        onSelect={() => setExpand(!expand)}
      > */}
      <Table wordWrap height={400} loading={loading} data={tableData} style={{ marginTop: '20px' }}>
        <Column width={70} align="center" fixed>
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column minWidth={120} flexGrow={1}>
          <HeaderCell>ปีงบประมาณ</HeaderCell>
          <Cell dataKey="budgetYear" />
        </Column>

        <Column minWidth={200} flexGrow={1}>
          <HeaderCell>สำนัก</HeaderCell>
          <Cell dataKey="department" />
        </Column>

        <Column minWidth={160} flexGrow={1}>
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column minWidth={250} flexGrow={1}>
          <HeaderCell>ชื่อโครงการ</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>

        <Column minWidth={200} flexGrow={1}>
          <HeaderCell>ผู้ประสานงาน</HeaderCell>
          <Cell dataKey="coordinator" />
        </Column>

        <Column minWidth={120} flexGrow={1}>
          <HeaderCell>วันที่เริ่มต้น</HeaderCell>
          <Cell dataKey="projectStartDate" />
        </Column>

        <Column minWidth={120} flexGrow={1}>
          <HeaderCell>วันที่สิ้นสุด</HeaderCell>
          <Cell dataKey="projectEndDate" />
        </Column>

        {!hideColumn?.dayOfDelay && (
          <Column minWidth={150} flexGrow={1}>
            <HeaderCell>จำนวนวันที่ล่าช้า</HeaderCell>
            <Cell dataKey="dayOfDelay" align="center" />
          </Column>
        )}

        <Column minWidth={160} flexGrow={1}>
          <HeaderCell>สถานะโครงการ</HeaderCell>
          <Cell dataKey="projectStatus" />
        </Column>

        <Column width={120} align="center" fixed="right">
          <HeaderCell>จัดการ</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <IconButton
                  appearance="ghost"
                  icon={<Icon appearance="ghost" icon="edit" className="bt-gost-icon-radius" />}
                  onClick={() => {
                    onSelect(rowData)
                  }}
                >
                  เลือก
                </IconButton>
              )
            }}
          </Cell>
        </Column>
      </Table>

      {pagination && (
        <TablePagination
          lengthMenu={defaultLengthMenu}
          activePage={page || defaultPage}
          renderLengthMenu={(lengthMenu) => {
            return (
              <>
                {lengthMenu}
                {`รายการ/หน้า`}
              </>
            )
          }}
          renderTotal={(total) => {
            return <>{` ทั้งหมด ${total} รายการ`}</>
          }}
          displayLength={displayLength || 5}
          total={schema.totalSize || 0}
          onChangePage={handleChangePage}
          onChangeLength={handleChangeLength}
        />
      )}
      {/* </Panel> */}
    </>
  )
}
